'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _mobx = require('mobx');

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _Field = require('./Field');

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Form = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = function () {
  (0, _createClass3.default)(Form, [{
    key: 'visibleFields',


    /**
     * All visible fields in this form.
     * @type {Array.<Field>}
     */


    /**
     * All fields in this form.
     * @type {Array.<Field>}
     */


    /**
     * The raw data provided by Drupal.
     */
    get: function get() {
      return this.fields.filter(function (field) {
        return field.visible;
      });
    }

    /**
     * All visible fields in this form of the current page.
     * @type {Array.<Field>}
     */


    /**
     * The unique key for this form.
     */

  }, {
    key: 'visibleFieldsOfCurrentPage',
    get: function get() {
      var _this = this;

      return this.visibleFields.filter(function (field) {
        return field.page === _this.page;
      });
    }
  }]);

  function Form(formId, _ref) {
    var _this2 = this;

    var settings = _ref.settings,
        form = _ref.form,
        _ref$defaultValues = _ref.defaultValues,
        defaultValues = _ref$defaultValues === undefined ? {} : _ref$defaultValues;
    (0, _classCallCheck3.default)(this, Form);
    this.key = null;

    _initDefineProp(this, 'settings', _descriptor, this);

    _initDefineProp(this, 'fields', _descriptor2, this);

    _initDefineProp(this, 'page', _descriptor3, this);

    _initDefineProp(this, 'isSubmitting', _descriptor4, this);

    this.key = formId;
    this.form = form;
    this.settings = settings;

    // Create all fields.
    this.form.elements.forEach(function (element) {
      return _this2.createField(element);
    });

    // Set all default values.
    (0, _keys2.default)(defaultValues).forEach(function (key) {
      var field = _this2.getField(key);
      if (field) field.value = defaultValues[key];
    });

    // Start at the first page
    var page = this.fields.find(function (f) {
      return f.page !== 'no-page';
    });
    if (page) this.page = page.page;
  }

  (0, _createClass3.default)(Form, [{
    key: 'createField',
    value: function createField(element, parent) {
      var _this3 = this;

      var field = new _Field2.default(this, element, parent);
      if (field.componentClass) this.fields.push(field);

      // If it has children, create them too.
      if (element.composite_elements) {
        element.composite_elements.forEach(function (e) {
          return _this3.createField(e, field);
        });
      }
    }

    /**
     * @param key
     * @returns {Field}
     */

  }, {
    key: 'getField',
    value: function getField(key) {
      return this.fields.find(function (field) {
        return field.key === key;
      });
    }
  }, {
    key: 'isValid',
    value: function isValid(page) {
      var invalid = this.fields.find(function (field) {
        // Only check the current page
        if (!field.component || field.component.props.webformPage !== page) return false;

        // If an error was found, return true
        return !field.valid;
      });

      // If an error was found, return false
      return !invalid;
    }
  }, {
    key: 'isMultipage',
    value: function isMultipage() {
      var _this4 = this;

      return ((0, _getNested2.default)(function () {
        return _this4.form.elements;
      }) || []).find(function (element) {
        return element['#webform_key'] === 'wizard_pages';
      }) !== undefined;
    }
  }, {
    key: 'values',
    get: function get() {
      var values = {};

      this.visibleFields.filter(function (field) {
        return !field.isEmpty;
      }).forEach(function (field) {
        values[field.key] = typeof field.componentClass.rewriteValue === 'function' ? field.componentClass.rewriteValue(field.value, values) : field.value;
      });

      return values;
    }
  }, {
    key: 'valid',
    get: function get() {
      return !this.fields.find(function (field) {
        return field.visible && !field.valid;
      });
    }
  }, {
    key: 'tokens',
    get: function get() {
      var _this5 = this;

      var tokens = {};
      this.fields.forEach(function (field) {
        tokens[field.key] = field.value;
        if (typeof field.componentClass.getTokens === 'function') {
          (0, _assign2.default)(tokens, field.componentClass.getTokens(_this5, field));
        }
      });
      return tokens;
    }
  }]);
  return Form;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'settings', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'fields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'page', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 'no-page';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'visibleFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'visibleFields'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'visibleFieldsOfCurrentPage', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'visibleFieldsOfCurrentPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createField', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'values', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'values'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'valid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'valid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tokens', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tokens'), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'isSubmitting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isMultipage', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isMultipage'), _class.prototype)), _class));
exports.default = Form;